import { useContext } from 'react';
import { Buttons, FlexContainer, ModalContext, Spinner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { useFetchPreviousYear } from 'Containers/Dashboard/hooks';
import { useFetchGetResult } from 'Containers/Result/hooks';
import PreviousYearsUpsell from 'Containers/UpsellFiling/components/PreviousYearsUpsell';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import CustomTransition from 'Components/CustomTransition';
import { ReviewModal } from 'Components/Modal/components';
import { routes } from 'Constants/routes';
import * as Styled from './styles';

const UpsellFiling = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { showModal } = useContext(ModalContext);
  const { isLoading: isLoadingResult } = useFetchGetResult();
  const { isLoading, data } = useFetchPreviousYear();
  const handleTinyClick = (): void => {
    showModal({
      comp: <ReviewModal />,
    });
  };

  return (
    <FlowColLayout section="filing" isFlow>
      <CustomTransition start>
        <Styled.Container direction="column" fullHeight align="center" justify="space-between">
          {(isLoading || isLoadingResult) && !data ? (
            <FlexContainer fullHeight align="center" justify="center">
              <Spinner size="M" align="center" />
            </FlexContainer>
          ) : (
            <PreviousYearsUpsell amount={data?.amountPending || 0} />
          )}
          <Styled.ButtonsContainer
            fullWidth
            direction="column"
            gap="dimension_16"
            justify="center"
            align="center"
          >
            <Buttons.Tiny label={t('PreviousYearsUpsell.tiny.button')} onClick={handleTinyClick} />
            <Buttons.Classic
              size="m"
              label={t('PreviousYearsUpsell.button')}
              mode="primary"
              onClick={() => history.push(routes.PREVIOUS_YEARS)}
            />
          </Styled.ButtonsContainer>
        </Styled.Container>
      </CustomTransition>
    </FlowColLayout>
  );
};

export default UpsellFiling;
